module.exports = __webpack_public_path__ + "static/media/luar.b7418309.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/luar.png
// module id = 132
// module chunks = 0